import { z } from "zod";

export const verifyEmailSchema = z.object({
  email: z
    .string()
    .trim()
    .min(1, "Email is required")
    .email("Enter a valid email address"),
});

export type VerifyEmailValues = z.infer<typeof verifyEmailSchema>;

export const phase2ValidateSuccessSchema = z.object({
  employeeId: z.number(),
  employeeName: z.string(),
  /** Present on error responses; used when `valid` is false. */
  message: z.string().optional(),
});

export type Phase2ValidateSuccess = z.infer<typeof phase2ValidateSuccessSchema>;

export const bankStepSchema = z.object({
  beneficiaryName: z
    .string()
    .trim()
    .min(3, "Name must be at least 3 characters")
    .max(140, "Name must be less than 300 characters")
    .regex(/^[a-zA-Z\s.]+$/, "Name should only contain alphabets, spaces, or dots"),
  /**
   * Indian Account Number:
   * 9 to 18 digits
   */  
  accountNumber: z
    .string()
    .trim()
    .regex(/^\d{9,18}$/, "Account number must be between 9 and 18 digits"),
  bankName: z.string().trim().min(2, "Please enter a valid bank name"),
  branchName: z.string().trim().min(2, "Please enter a valid branch name"),
  /**
   * IFSC Code:
   * 4 alphabets (Bank code)
   * 0 (Control character)
   * 6 alphanumeric characters (Branch code)
   */
  ifscCode: z
    .string()
    .trim()
    .toUpperCase()
    .regex(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Invalid IFSC code format (e.g., SBIN0123456)"),
});

export type BankStepValues = z.infer<typeof bankStepSchema>;
